import React, {useState, useContext} from 'react';
import { Dimensions, View } from 'react-native';
import {
  ChatModal,
  ModalContainer,
  ModalContent,
} from './elements';
import ChatHeader from './ChatHeader';
import MessageInputContext from '../../contexts/MessageInputContext';

const Modal = props => {
  const {
    setCurrentConversationId,
    addToCollapsed,
    removeFromOpens,
    conversationsIndex
  } = useContext(MessageInputContext);
  const {
    showModal,
    setShowModal,
    modalType,
    children,
    objectName,
    pendingResponse,
    conversationId
  } = props;
  const screenHeight = Dimensions.get('window').height - 100
  return (
    <ModalContainer
      // onPress={() => setShowModal(false)}
      // width='75%'
    >
      {/* <DefaultModal
        visible={showModal}
        transparent={true}
      > */}
        <ChatModal
          onClick={() => false}
          conversationsIndex={conversationsIndex}
        >
          <ChatHeader
            title={`${modalType}${objectName ? ' - ' + objectName : ''}`}
            pendingResponse={pendingResponse}
            onMinimize={() => addToCollapsed(conversationId)}
            onClose={() => removeFromOpens(conversationId)}
          />
          <ModalContent>
            <View style={{ height: "auto", maxHeight: screenHeight, flex: 1 }}>
              { children }
            </View>
          </ModalContent>
        </ChatModal>
      {/* </DefaultModal> */}
    </ModalContainer>
  )
}

export default Modal;